import React, { useEffect, useState } from "react";
// import ManImage from "../assets/Image/man.png";
import { useLocation, NavLink } from "react-router-dom";
import { BiUser, BiPowerOff, BiMenu } from "react-icons/bi";
import { Navlinks } from "./Sidebar";
import REACT_APP_API_URL from "../utils/constant";
const REACT_APP_IMAGEPATH = process.env.REACT_APP_IMAGEPATH;
const Header = ({ toggleMenu }) => {
  const [image, setImage] = useState("");
  const [full_name, setFirstName] = useState("");
  const [isLoading, setIsLoading] = useState(true); // Track loading state

  // console.log(">>>>>>hedare ", image);

  useEffect(() => {
    getAdminDetails();
  }, []);
  const getAdminDetails = async () => {
    try {
      let result = await fetch(`${REACT_APP_API_URL}get-profile`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("user")}`,
        },
      });
      result = await result.json();
      // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>header page ", result);
      if (result) {
        setFirstName(result.data.full_name);
        // Goose-Web/Backend/public/data/adminImages/1740654875838.jpg
        // Ensure image path is correct
        const imagePath = result.data.image;
        setImage(imagePath);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };
  const location = useLocation();
  // console.log(location.pathname); // "/add-explore"
  let title = "Dashboard"; // default title

  if (location.pathname.startsWith("/explore/add")) {
    title = "Add Explore";
  } else if (location.pathname.startsWith("/explore/detail")) {
    title = "Detail Explore";
  } else if (location.pathname.startsWith("/explore/edit")) {
    title = "Edit Explore";
  } else if (location.pathname.startsWith("/explore")) {
    title = "Explore";
  } else if (location.pathname.startsWith("/links")) {
    title = "Links";
  } else if (location.pathname.startsWith("/users")) {
    title = "Users";
  } else if (location.pathname.startsWith("/notification")) {
    title = "Notifications";
  } else if (location.pathname.startsWith("/aboutus")) {
    title = "About Us";
  } else if (location.pathname.startsWith("/privacy")) {
    title = "Privacy Policy";
  } else if (location.pathname.startsWith("/terms&conditions")) {
    title = "Terms & Conditions";
  } else if (location.pathname.startsWith("/account")) {
    title = "Account";
  } else {
    title = "Dashboard";
  }

  // const activeLink = Navlinks.find((link) => link.path === location.pathname);

  return (
    <nav
      className="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
      id="layout-navbar"
    >
      <div className="layout-menu-toggle navbar-nav align-items-xl-center me-4 me-xl-0 d-xl-none">
        <button className="nav-item nav-link px-0 me-xl-6" onClick={toggleMenu}>
          <BiMenu className="bx bx-menu bx-md" />
        </button>
      </div>

      <div
        className="navbar-nav-right d-flex align-items-center"
        id="navbar-collapse"
      >
        <div className="navbar-nav align-items-center">
          <div className="nav-item d-flex align-items-center">
            <h5 className="m-0">{title}</h5>
          </div>
        </div>

        <ul className="navbar-nav flex-row align-items-center ms-auto">
          <li className="nav-item navbar-dropdown dropdown-user dropdown">
            <a
              className="nav-link dropdown-toggle hide-arrow p-0"
              href="/"
              data-bs-toggle="dropdown"
            >
              {/* <div className="avatar avatar-online">
                <img
                  src={image} // Fallback if no image
                  alt="Profile"
                  className="rounded-circle"
                  style={{ height: 40, objectFit: "cover", width: 40 }}
                />
              </div> */}
              <div className="avatar avatar-online">
                {isLoading ? (
                  <div
                    className="shimmer-loader"
                    style={{ width: 40, height: 40, borderRadius: "50%" }}
                  ></div>
                ) : (
                  <img
                    src={image}
                    alt="Profile"
                    className="rounded-circle"
                    style={{ height: 40, objectFit: "cover", width: 40 }}
                  />
                )}
              </div>
            </a>
            <ul className="dropdown-menu dropdown-menu-end">
              <li>
                <a className="dropdown-item" href="/account">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-3">
                      {/* <div className="avatar avatar-online">
                        <img
                          src={image}
                          alt=""
                          className="w-px-40 h-auto rounded-circle"
                        />
                      </div> */}
                      <div className="avatar avatar-online">
                        {isLoading ? (
                          <div
                            className="shimmer-loader"
                            style={{
                              width: 40,
                              height: 40,
                              borderRadius: "50%",
                            }}
                          ></div>
                        ) : (
                          <img
                            src={image}
                            alt=""
                            className="w-px-40 h-px-40 rounded-circle"
                          />
                        )}
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mb-0">{full_name}</h6>
                    </div>
                  </div>
                </a>
              </li>
              <li>
                <div className="dropdown-divider my-1"></div>
              </li>
              <li>
                <NavLink className="dropdown-item" 
                to={"/account"}>
                  <BiUser className="bx-md me-3" />
                  <span>My Profile</span>
                </NavLink>
              </li>
              <li>
                <div className="dropdown-divider my-1"></div>
              </li>
              <li>
                <NavLink className="dropdown-item" 
                to={"/login"}>
                  <BiPowerOff className="bx-md me-3" />
                  <span>Log Out</span>
                </NavLink>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Header;
